import { Serializable } from '@admin/core/models/serializable';
import { ProductTypeModel } from '@admin/product-purchases/shared/models/product-type-model';
import { ProviderWebsiteModel } from '@admin/shared/models/provider-website-model';

export class MonthlyPlanProductType
  implements Serializable<MonthlyPlanProductType>
{
  public monthlyPlanProductTypeId: number;
  public monthlyPlanId: number;
  public productType: ProductTypeModel;
  public website: ProviderWebsiteModel;
  public totalCount: number;
  public soldCount: number;

  fromObject(object: any): MonthlyPlanProductType {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    return {
      MonthlyPlanProductTypeId: this.monthlyPlanProductTypeId,
      MonthlyPlanId: this.monthlyPlanId,
      ProductType: this.productType.toObject(),
      Website: this.website.toObject(),
      TotalCount: this.totalCount,
      SoldCount: this.soldCount,
    };
  }
}
